import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
  gap: 1.5rem;

  &&& .checkbox-column,
  .id-column {
    width: 2rem;
    padding: 1rem;
    min-width: 0;
  }
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;
